import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import endOfMonth from "date-fns/end_of_month";
import subMonths from 'date-fns/sub_months';
import axios from 'axios'
import { ensureReportAuth } from './core/reportAuth'
import { getUsersByCompany } from './cacheService'

// mounted() ใน wv-monthly-insights.vue มี if/else ผิด: lang=TH ถูกเขียนทับเป็น EN
// getUser ทำงาน async หลัง mounted จึง apply ภาษาจาก ?lang= อีกครั้งก่อน commit user
const applyReportLangFromUrl = () => {
    const lang = new URLSearchParams(window.location.search).get('lang')
    if (lang && lang.toUpperCase() === 'TH') {
        localStorage.setItem('lang', 'TH')
    } else if (lang && lang.toUpperCase() === 'MS') {
        localStorage.setItem('lang', 'MS')
    } else if (lang) {
        localStorage.setItem('lang', 'EN')
    }
}

const apiUrl = 'http://54.179.6.33:3000'
//const apiUrl = 'http://localhost:3000'
export default {
    namespaced: true,
    state: {
        user:'',
        teamAll:'',
        dailyContributions:'',
        managerRate:[],
        recognitionGiven:[],
        feedback:[],
        youFeeling:[],
        teamFeeling:[],
        feeling:[],
        performingData:[],
        talentTeam:{},
        directReportsCardData:[],
        organizations: [],
        organization1level: {},
        userCardData:[],
        loadingStatus: false,
        growingData: {},
    },
    mutations: {
        setUser(state:any, result:any) {
            state.user = result
        },
        setTeamAll(state:any, result:any) {
            state.teamAll = result
        },
        setContributions(state:any, result:any) {
            state.dailyContributions = result
        },
        setManagerRate(state:any, result:any) {
            state.managerRate = result
        },
        setRecognitionGiven(state:any, result:any) {
            state.recognitionGiven = result
        },
        setFeedback(state:any, result:any) {
            state.feedback = result
        },
        setYouFeeling(state:any, result:any) {
            state.youFeeling = result
        },
        setTeamFeeling(state:any, result:any) {
            state.teamFeeling = result
        },
        setFeeling(state:any, result:any) {
            state.feeling = result
        },
        setPerformingData(state:any, result:any) {
            state.performingData = result
        },
        setTalentTeam(state:any, result:any) {
            state.growingData = result
        },
        setPartTalentTeam(state:any, result:any) {
           
            state.directReportsCardData = result
        },
        setOrganizations(state: any, value: any) {
            state.organizations = value
        },
        setuserCardData(state: any, value: any) {
            state.userCardData = value
        },
        setloadingStatus(state: any, value: any) {
            state.loadingStatus = value
        },
   
   
    },
    actions: {
        async getUser({ commit, dispatch, rootState, state }: any, value: any){
            await ensureReportAuth()
            const emailKey = value.email.replace(/\./g, '||')
            // const m=parseInt(value.month)>9?value.month:value.month.replace('0','')
            // const _month=format( new Date(m),"MMM")
            const _month = format(new Date(`${value.year}-${value.month}-01`),'MMM')
            const userData = (await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
           
            
            if(userData){
                firebase.auth().onAuthStateChanged(async function(user) {
                    if (user) {
                        console.log("User is signed in.")
                        const boss = (await firebase.database().ref(`/boss/${userData.company}/${emailKey}`).once('value')).val()
                        var teamBoss=""
                        if(!boss){
                            const emailKeyBoss = userData.boss.replace(/\./g, '||')
                            const userDataBoss = (await firebase.database().ref(`/users/${emailKeyBoss}`).once('value')).val()
                            teamBoss=userDataBoss.team
                        }else{
                            teamBoss=userData.team
                        }
                        await dispatch("getOrganization",{company:userData.company,team:teamBoss});
                        const team = (await firebase.database().ref(`/team/${userData.team}`).once('value')).val()
                        
                        const _user = {
                            id: userData.email,
                            company:userData.company,
                            name: (userData.firstname+" "+userData.lastname.slice(0, 1)),
                            firstname: userData.firstname,
                            lastname: userData.lastname,
                            image: userData.profilepic,
                            month: _month,
                            num_month: value.month,
                            year: value.year,
                            email: userData.email,
                            teamName:team.name,
                            teamid:userData.team,
                            boss:boss?true:false,
                            superFeedback:userData.super_feedback_count_month,
                            house:userData.house,
                            pic:userData.profilepic,
                            teamColor: "",
                            key:emailKey,
                            bossName:userData.boss,
                            talent:userData.talent,
                            star:userData.star
                        }
                        applyReportLangFromUrl()
                        commit('setUser', _user)
                        
                    } else {
                        console.log('No user is signed in.')
                        await ensureReportAuth().then(async (res) => {
                            await dispatch("getOrganization",{company:userData.company,team:userData.team});
                            const team = (await firebase.database().ref(`/team/${userData.team}`).once('value')).val()
                            const boss = (await firebase.database().ref(`/boss/${userData.company}/${emailKey}`).once('value')).val()
                            const _user = {
                                id: userData.email,
                                company:userData.company,
                                name: (userData.firstname+" "+userData.lastname.slice(0, 1)),
                                firstname: userData.firstname,
                                lastname: userData.lastname,
                                image: userData.profilepic,
                                month: _month,
                                num_month: value.month,
                                year: value.year,
                                email: userData.email,
                                teamName:team.name,
                                teamid:userData.team,
                                boss:boss?true:false,
                                superFeedback:userData.super_feedback_count_month,
                                house:userData.house,
                                pic:userData.profilepic,
                                teamColor: "",
                                key:emailKey,
                                bossName:userData.boss,
                                talent:userData.talent,
                                star:userData.star
                            }
                            applyReportLangFromUrl()
                            commit('setUser', _user)
                        })
                    }
                });
            }
        },
        getOrganization({ commit,dispatch,state, rootState }: any,value:any) {
            if(state.organizations.length == 0){
              firebase.firestore().collection('organization').where("company", "==",value.company).get()
              .then(function (querySnapshot) {
                const organizations: Array<any> = [];
                querySnapshot.forEach((doc) => {
                  const organization = doc.data()
                  organization.key = doc.id
                  organizations[organization.team_id] = organization
                });
                commit('setOrganizations', organizations)
                dispatch("getTeamAll",value.team);
              });
            }
        },
        async getTeamOfParent({ commit, dispatch, rootState, state }: any, item: any) {
            const organization1level = state.organization1level
            _.forEach(item, (value)=> {
                organization1level[value.team_id] = true
                if(value.parent){
                    dispatch('getTeamOfParent', value.parent)
                }
            });
        },
        async getTeamAll({ commit, dispatch, rootState, state }: any,team) {

            const organizations = state.organizations
            state.organization1level = {}
            const organization1level = state.organization1level
            const teams = organizations[team]
          
            if(teams){
                organization1level[teams.team_id] = true
                _.forEach(teams.parent, (value)=> {
                    organization1level[value.team_id] = true
                    if(value.parent){
                        dispatch('getTeamOfParent', value.parent)
                    }
                });
            }else{
                organization1level[state.user.teamid] = true
            }
            commit('setTeamAll',organization1level)
     
           

        },
        async getUserTeam({ commit, dispatch, rootState, state }: any, value: any){
            commit("setloadingStatus",true)
            let userCardData: any = {};
            let talentTeam: { [key: string]: any } = {};
            let team: Array<any> = [];
            let excelsAt: { [key: string]: any } = {};
            let peerfeedback: Array<any> = [];
            let pastMonth = value.num_month - 1;
            let year = parseInt(format(value.year, "YYYY"));
            let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
            var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
            const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
            const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
            let countTruly:{ [key: string]: any } = {};
            let OldtalentTeam:{ [key: string]: any } = {};
            let allUserKey = {}
            let directReports: Array<any>=[
                // {name: "Underutilized",value: 0},
                // {name: "Activated",value: 0},
                // {name: "High Performer",value: 0},
                // {name: "Superstar",value: 0},
                // {name: "Supported",value: 0},
                // {name: "High Contributor",value: 0},
                // {name: "Core Player",value: 0},
                // {name: "Solid Performer",value: 0},
                // {name: "Up-and-coming", value: 0},
                // {name: "Rising Star",value: 0},
                // {name: "Developing",value: 0},
                // {name: "High Potential",value: 0},
                // {name: "Marginalized",value: 0},
                // {name: "Contributor",value: 0},
                // {name: "Crowd Favorite",value: 0},
                // {name: "Hidden Talent",value: 0},
                {name: "Untapped Potential",value: 0},
                {name: "Activated",value: 0},
                {name: "High Performer",value: 0},
                {name: "Superstar",value: 0},
                {name: "Community Pillar",value: 0},
                {name: "Engaged Contributor",value: 0}, 
                {name: "Core Player",value: 0},
                {name: "Solid Performer",value: 0},
                {name: "Up-and-coming", value: 0},
                {name: "Rising Star",value: 0},
                {name: "Emerging Talent",value: 0},
                {name: "High Potential",value: 0},
                {name: "Latent Potential",value: 0},
                {name: "Contributor",value: 0},
                {name: "Crowd Favorite",value: 0},
                {name: "Unsung Talent",value: 0},
              ]
            // for(const teamId in state.teamAll){
                axios.post(`${apiUrl}/talent`, {
                    // headers:headers
                    //email: allUserKey[user].email,
                    date:value.year+'-'+value.num_month+'-'+lastDayOfMonth,
                    team:state.teamAll,
                    company:value.company,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET,HEAD,PUT,PATCH,POST,DELETE'
                    }
                    })
                    .then(function (response) {
                        const data = response.data
                        
                        data.map(value=>{
                 
                            const emailKey = value.email.replace(/\./g, '||')
                            OldtalentTeam[emailKey]=value.talent_before
                        })
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            // }

            //const userCompany = (await firebase.database().ref('users').orderByChild("company").equalTo(state.user.company).once('value')).val()
            const _usersByCompany = await getUsersByCompany(state.user.company)
            Object.values(_usersByCompany).forEach((childData:any) => {
                    let _data = childData;
                    const emailKey = _data.email.replace(/\./g, '||')
                    if(state.teamAll[_data.team]){
                            allUserKey[emailKey]=_data
                    }
            })
            //received
            await firebase.firestore().collection('peerfeedback').where('company','==',state.user.company).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
                snapshot.forEach(childSnapshot => {
                    var _data = childSnapshot.data()
                        peerfeedback.push(_data)
                        
                })
                for (const user in allUserKey) {
           
                    let excels: Array<any> = [];
                    let received =_.filter(peerfeedback,function (currentObject) {
                            return currentObject.email_to==allUserKey[user].email
                        })
                    if(received){
                        received.map(value=>{
                            value.excels.map(data=>{
                                excels.push(data)
                            })
                            if(value.suggest.line1_en==="Truly"){
                                if(!countTruly[user]){
                                    countTruly[user]=0
                                }
                                countTruly[user]++
                            }
                        })
                    }
                    var result = _(excels).groupBy('name').map(function(items, bdate) {
                        return {name: bdate,value: items.length};
                    }).value();
                    excelsAt[user]=result
                }

            })

            for (const user in allUserKey) {

                if(talentTeam[allUserKey[user].talent]!=undefined)
                {
                    talentTeam[allUserKey[user].talent]++
                }else {
                    talentTeam[allUserKey[user].talent]=1
                }


                            if(allUserKey[user].email!==value.email){
                               
                                                            
                                    team.push({
                                        name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
                                        firstname: allUserKey[user].firstname,
                                        lastname: allUserKey[user].lastname,
                                        image:allUserKey[user].profilepic,
                                        talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
                                        email:allUserKey[user].email,
                                        starPerformer:allUserKey[user].star,
                                        talent:allUserKey[user].talent,
                                        oldTalent:OldtalentTeam[user]?OldtalentTeam[user]:"",
                                        excelsAt:excelsAt[user],
                                        excelsCount:Object.entries(excelsAt[user]).length.toString(),
                                        outstanding:countTruly[user]?countTruly[user]:0
                                    })
                                
                            }else{
                                userCardData={
                                    name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
                                    firstname: allUserKey[user].firstname,
                                    lastname: allUserKey[user].lastname,
                                    image:allUserKey[user].profilepic,
                                    talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
                                    email:allUserKey[user].email,
                                    starPerformer:allUserKey[user].star,
                                    talent:allUserKey[user].talent,
                                    oldTalent:OldtalentTeam[user]?OldtalentTeam[user]:"",
                                    excelsAt:excelsAt[user],
                                    outstanding:countTruly[user]?countTruly[user]:0
                                }
                                
                                commit('setuserCardData', userCardData)
                            }
     
                
            }

            directReports.map(value=>{
                const emailKey = state.user.email.replace(/\./g, '||')
                value.value=talentTeam[value.name]?talentTeam[value.name]:0
                value.highlight=state.user.talent===value.name?true:false
                value.oldhighlight=OldtalentTeam[emailKey]===value.name?true:false
            })
            commit('setTalentTeam', {directReports:directReports})
            setTimeout(() => {
                commit('setPartTalentTeam',_.orderBy(team, ['excelsCount', 'name'], ['desc','asc']))
                commit("setloadingStatus",false)
              }, 3000)

        },
        async getContributions({ commit, dispatch, rootState, state }: any, value: any){
           await dispatch('getrecognitionGiven')
           await dispatch('getManagerRate')
           let status_feeling={good: 0,okay: 0,critical: 0}
           let count:any
           let weekend=0
           let totalday=0
           let available_feedbackShare=0
           let month = parseInt(state.user.num_month);
           let pastMonth = month - 1;
           let year = parseInt(format(state.user.year, "YYYY"));
           let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
           var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
           const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
           const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
           let holiday: Array<any> = [];
           let answer: Array<any> = [];
           let feeling: Array<any>=[];
           let youFeeling: Array<any>=[];
           var _data:any
           let Peerfeedback=0
           let feedback=0
        //    //given
        //    await firebase.firestore().collection('peerfeedback').where('company','==',state.user.company).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
        //        snapshot.forEach(childSnapshot => {
        //            var _data = childSnapshot.data()
        //            if(_data.email==state.user.email){
        //                Peerfeedback++
        //                // console.log("peerfeedback",_data)
        //            }
        //        })
        //    })
        //    await firebase.firestore().collection('/users_questions').where('users','==',state.user.email).where('date','>=',start_date).where('date','<=',end_date).get().then((querySnapshot)=>{
        //     querySnapshot.forEach((doc) => {
        //         const data=doc.data()
        //         if(data.quest_id==="-Kgs61AHOnpJ3rfyQr6t"){
        //             feeling.push(data)
        //             //console.log("users_questions",data)
        //         }
        //         if(data.type=="Text Area Field"|| value.parent == "Y"){
        //             available_feedbackShare++
        //             //console.log("users_questions",data)
        //         }
        //         })
        //     })

           firebase.firestore().collection('/holliday').where('companyid','==',state.user.company).where('date','>=',start_date).where('date','<=',end_date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                holiday.push(data)        
            })
            for(var i=1;i<=lastDayOfMonth;i++){
                var day=format(new Date(year,pastMonth,i), 'E');
                if(day=="6"||day=="7"){
                    weekend++
                }
                var data = _.find(holiday, function(value){
                    return value != null && parseInt(value.d) == i;
                  });
                if(!data){
                    totalday++
                }
            }
            
        })
            firebase.firestore().collection('users_questions').where('users','==',state.user.email).where('date','>=',start_date).where('date','<=',end_date).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    if(data.quest_id==="-Kgs61AHOnpJ3rfyQr6t"&&data.answer){
                        answer.push(data)
                    }
                    if(data.quest_id==="-Kgs61AHOnpJ3rfyQr6t"){
                        feeling.push(data)
                        //console.log("users_questions",data)
                    }
                    if(data.type=="Text Area Field"|| data.parent == "Y"){
                        //console.log("available_feedbackShare",data)
                        available_feedbackShare++
                        if(data.answer){
                            feedback++
                        }
                        //console.log("users_questions",data)
                    }
                    //requested 
                    if(data.priority==20){
                        Peerfeedback++
                        //console.log("peerfeedback_requested",_data)
                    }
            })
            let status :any
            let status_Peerfeedback:any
            const group = _.countBy(answer, 'date');
            // let feedback = _.filter(answer, function(value){
            //     return value != null && value.answer &&( value.parent == "Y"|| value.type == "Text Area Field");
            //   });
            // console.log("feedback",feedback)
            count=Math.round((Object.keys(group).length)*100/(totalday-weekend))>100?100:Math.round((Object.keys(group).length)*100/(totalday-weekend));
             
            if(count>=75){
                status='green'
            }else if(count>=50){
                status='yellow'
            }else {
                status='red'
            }
            // console.log("feedbackShare",feedback)
            let feedbackShare_status=""
            let feedbackShare =Math.round((feedback)*100/(available_feedbackShare) );
            if(feedbackShare>=75){
                feedbackShare_status='green'
            }else if(feedbackShare>=40){
                feedbackShare_status='yellow'
            }else {
                feedbackShare_status='red'
            }
            if(Peerfeedback>=1){
                status_Peerfeedback='green'
            }else {
                status_Peerfeedback='red'
            }
             _data={
                dailyAttendance:count,
                dailyAttendanceStatus:status,
                feedbackShared:feedback,
                feedbackSharedStatus: feedbackShare_status,
                ...state.managerRate,
                ...state.recognitionGiven,
                peerFeedback: Peerfeedback,
                peerFeedbackStatus: status_Peerfeedback,
            }
         
            for(let j=0;j<lastDayOfMonth;j++){
                const day=(j+1)<10?"0"+(j+1):(j+1)
                const date=state.user.year+"-"+state.user.num_month+"-"+day
                let weekend = format(date, "dd");
                //console.log("weekend",weekend,date)
               
                if(weekend!=="Su"&&weekend!=="Sa"){
                const _filter=_.find(feeling, function (data) {
                    return data != null && data.date == date;
                  });
                var _holiday = _.find(holiday, function(value){
                    return value != null && value.date == date;
                  });
                    if(j==0){
                        let dayLabel = format(date, "d");
                        
                        for(let i=1;i<parseInt(dayLabel);i++){
                            youFeeling.push("#DBDBDB")
                            
                        }
                        
                    }
                    if(_filter&&!_holiday){
                        if(_filter.answer===0||_filter.answer===1)
                        {
                            youFeeling.push("#27BC6C")
                            status_feeling.good++
                            
                        }else if(_filter.answer===2)
                        {
                            youFeeling.push("#FFBA0D")
                            status_feeling.okay++
                            
                        }
                        else if(_filter.answer===3||_filter.answer===4)
                        {

                            youFeeling.push("#F22F3C")
                            status_feeling.critical++
                            
                        }else{
                            youFeeling.push("#7B7B7B")
                        }
                    }else{
                        if(_holiday){
                            
                            youFeeling.push("#DBDBDB")
                            
                        }else{
                            
                            youFeeling.push("#7B7B7B")
                            
                        }
                    }
                }
                if(j==lastDayOfMonth-1)
                {
                    
                    if(youFeeling.length<25){
                        for(let i=youFeeling.length;i<25;i++)
                        {
                            youFeeling.push("#DBDBDB")
                            
                        }
                        
                    }

                }
                
            }

            if(!state.user.boss){
                commit('setFeeling', status_feeling)
            }
            commit('setYouFeeling', youFeeling)
            commit('setContributions', _data)
        })
            
        },
        getManagerRate({ commit, dispatch, rootState, state }: any, value: any) {
            let temp: Object = {};
            let managerRate_read=0
            let managerRate_receive=0
            let OpenMail_read=0
            let OpenMail_receive=0
            const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
            const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
                firebase.firestore().collection('insight_manager_today').where("email","==",state.user.email).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
                    snapshot.forEach(childSnapshot => {
                        var _data = childSnapshot.data()
                       if(_data.type==="feedback"){
                        managerRate_read = managerRate_read + _data.read
                        managerRate_receive = managerRate_receive + _data.receive
                       }else if( _data.type==="report_daily_boss" || _data.type==="report_weekly_boss"){
                        OpenMail_read=OpenMail_read+_data.read
                        OpenMail_receive=OpenMail_receive+_data.receive
                       }
                    })
                    const managerReplyRate=`${(isNaN(Math.round(managerRate_read * 100 / managerRate_receive)) ? 0 : (Math.round(managerRate_read * 100 / managerRate_receive)>100?"100":Math.round(managerRate_read * 100 / managerRate_receive)))}`
                    let status
                    if(parseInt(managerReplyRate)>=60){
                        status='green'
                    }else if(parseInt(managerReplyRate)>=30){
                        status='yellow'
                    }else {
                        status='red'
                    }
                    const OpenMail_total=`${(isNaN(Math.round(OpenMail_read * 100 / OpenMail_receive)) ? 0 : (Math.round(OpenMail_read * 100 / OpenMail_receive)>100?"100":Math.round(OpenMail_read * 100 / OpenMail_receive)))}`
                    let status_OpenMail
                    if(parseInt(OpenMail_total)>=75){
                        status_OpenMail='green'
                    }else if(parseInt(OpenMail_total)>=40){
                        status_OpenMail='yellow'
                    }else {
                        status_OpenMail='red'
                    }
                    temp = {
                        managerReplyRate:`${managerReplyRate}`,
                        managerReplyRateStatus:status,
                        insightsOpened:OpenMail_read,
                        insightsOpenedStatus:status_OpenMail
                      }
                   
                    commit('setManagerRate', temp)
                });
        },
        async getrecognitionGiven({ commit, dispatch, rootState, state }: any, value: any){
            let recognitionGiven:Array<any> = [];
            const emailKey = state.user.email.replace(/\./g, '||')
            const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
            const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
            const boss = (await firebase.database().ref(`/boss/${state.user.company}/${emailKey}`).once('value')).val()
            firebase.firestore().collection('here_point').where("company","==",state.user.company).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
                snapshot.forEach(childSnapshot => {
                    var _data = childSnapshot.data()
                    if(_data.statusrow !== undefined&&_data.sender_email==state.user.email)//if(_data.sender_email==state.user.email&&(_data.type==="gem"||_data.type==="coin"))
                    {
                        recognitionGiven.push(_data)
                    }
                })
                let status=""
                const opportunities=boss?7:6
                const count=Math.round((recognitionGiven.length)*100/(opportunities) );
                if(count>=50){
                    status='green'
                }else if(count>=25){
                    status='yellow'
                }else {
                    status='red'
                }
                const temp = {
                    recognitionGiven:`${recognitionGiven.length}`,
                    recognitionGivenStatus:status,
                  }
                commit('setRecognitionGiven', temp)
                
            })
        },
        async getPeerFeedback({ commit, dispatch, rootState, state }: any, value: any){
            const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
            const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
            let Peerfeedback=0

            //given
            await firebase.firestore().collection('peerfeedback').where('company','==',state.user.company).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
                snapshot.forEach(childSnapshot => {
                    var _data = childSnapshot.data()
                    if(_data.email==state.user.email){
                        Peerfeedback++
                        // console.log("peerfeedback",_data)
                    }
                })
            })
            //requested 
            firebase.firestore().collection('users_questions').where("users","==",state.user.email).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
                snapshot.forEach(childSnapshot => {
                    var _data = childSnapshot.data()
                    if(_data.priority==20){
                        Peerfeedback++
                        //console.log("peerfeedback_requested",_data)
                    }
                    
                })
                if(Peerfeedback>=1){
                    status='green'
                }else {
                    status='red'
                }
                const temp={
                    peerFeedback: Peerfeedback,
                    peerFeedbackStatus: status,
                }
                // console.log("temp",temp)
                commit('setFeedback', temp)
            })
        },
        getinsight_team({ commit, dispatch, rootState, state }: any, value: any){
            const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
            const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
            let month = parseInt(state.user.num_month);
            let status_feeling={good: 0,okay: 0,critical: 0}
            let pastMonth = month - 1;
            let year = parseInt(format(state.user.year, "YYYY"));
            let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
            var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
            let team_feeling: Array<any>=[];
            let Feeling:Array<any>=[];
            let holiday:Array<any>=[];
           firebase.firestore().collection('/holliday').where('companyid','==',state.user.company).where('date','>=',start_date).where('date','<=',end_date).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                holiday.push(data)        
                })
            })
            firebase.firestore().collection('insight_teams').where('company','==',value.company).where('date', '>=', `${start_date}`).where('date', '<=', end_date).get().then(snapshot => {
                snapshot.forEach(childSnapshot => {

                    var _data = childSnapshot.data()
                    if(_data.quest_id=='-Kgs61AHOnpJ3rfyQr6t'&&state.teamAll[_data.team])
                    {
                        team_feeling.push(_data)
                    }
                        
                })
                for(let j=0;j<lastDayOfMonth;j++){
                    const day=(j+1)<10?"0"+(j+1):(j+1)
                    const date=state.user.year+"-"+state.user.num_month+"-"+day
                    let weekend = format(date, "dd");
                   
                    if(weekend!=="Su"&&weekend!=="Sa"){
                    const _filter=_.find(team_feeling, function (data) {
                        return data != null && data.date == date;
                      });
                      

                    var _holiday = _.find(holiday, function(value){
                        return value != null && value.date == date;
                      });
                  
                        if(j==0){
                            let dayLabel = format(date, "d");
                            for(let i=1;i<parseInt(dayLabel);i++){
                                Feeling.push("#DBDBDB")
                            }
                        }
                        if(_filter&&!_holiday){
                        
                            if(_filter.color==="green")
                            {
                                Feeling.push("#27BC6C")
                                status_feeling.good++
                            }else if(_filter.color==="yellow")
                            {
                                Feeling.push("#FFBA0D")
                                status_feeling.okay++
                            }
                            else if(_filter.color==="red")
                            {
                                Feeling.push("#F22F3C")
                                status_feeling.critical++
                            }
                            else{
                                Feeling.push("#7B7B7B")
                            }
                        }else{
                            if(_holiday){
                                Feeling.push("#DBDBDB")
                            }else{
                                Feeling.push("#7B7B7B")
                            }
                        }
                    }
                    if(j==lastDayOfMonth-1)
                    {
                        if(Feeling.length<25){
                            for(let i=Feeling.length;i<25;i++)
                            {
                                Feeling.push("#DBDBDB")
                            }
                            
                        }
    
                    }

                }
                if(state.user.boss){
                    commit('setFeeling', status_feeling)
                }
                commit('setTeamFeeling', Feeling)

            })
        },
        async getPerforming ({ commit, dispatch, rootState, state }: any, value: any) {
            let performingData:Array<any>=[]
            let PersonalGrowth:any={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Recognition:any={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Rel_Colleagues:any={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Satisfaction:any={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Ambassadorship:any={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Feedback:any={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Wellness:any={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Company_Alignment:any={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            let Rel_Manager:any={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            const start_date=state.user.year+"-"+state.user.num_month+"-"+"01"
            const end_date=state.user.year+"-"+state.user.num_month+"-"+"31"
            const previous_start_date = format(subMonths(start_date,1), 'YYYY-MM-DD')
            const previous_end_date = format(subMonths(end_date,1), 'YYYY-MM-DD')
            if(state.user.boss){
                await firebase.firestore().collection('/users_questions').where('team','==',state.user.teamid).where('date','>=',start_date).where('date','<=',end_date).get().then((querySnapshot)=>{
                    querySnapshot.forEach((doc) => {
                        const data=doc.data()
                        //Personal Growth
                         if(data.quest_id=='-Kgn7oxLPPWlbM_ZDc_h')
                         {
                             if(data.answer!==undefined){
                                PersonalGrowth.total++
                                if(data.answer===0){
                                    PersonalGrowth.value++
                                 }
                             }
                             
                         }
                         else if(data.quest_id=='-L0J5FFsGQYVkfcGujWo'){
                           //console.log("Recognition",data)
                           if(data.answer!==undefined){
                            Recognition.total++
                            if(data.answer===0){
                                Recognition.value++
                             }
                         }
                         }
                         else if(data.quest_id=='-Kgs549ClADmNQwoNbbG'){
                           //console.log("Relationship with Colleagues",data)
                           if(data.answer!==undefined){
                            Rel_Colleagues.total++
                            if(data.answer===0){
                                Rel_Colleagues.value++
                             }
                         }
                         }
                         else if(data.quest_id=='-L1FmpFO-v8IZc_B5EB7'){
                            if(data.answer!==undefined){
                                Satisfaction.total++
                                if(data.answer===0||data.answer===1){
                                    Satisfaction.value++
                                 }
                            }
                        
                         }
                         else if(data.quest_id=='-L2ycGiBDo3rDGjLNKwW'){
                            //console.log("Ambassadorship",data)
                            if(data.answer!==undefined){
                                Ambassadorship.total++
                                if(data.answer===0){
                                    Ambassadorship.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-L1QWPtZvax_KlJgpNxF'){
                            //console.log("Feedback",data)
                            if(data.answer!==undefined){
                                Feedback.total++
                                if(data.answer===0){
                                    Feedback.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-L1Qug-PhtzVOR2Dr5q7'){
                            //console.log("Relationship with Managers",data)
                            if(data.answer!==undefined){
                                Rel_Manager.total++
                                if(data.answer===0){
                                    Rel_Manager.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-L36rxTgLhZTL4mq4SV1'){
                            //console.log("Wellness",data)
                            if(data.answer!==undefined){
                                Wellness.total++
                                if(data.answer===1||data.answer===2||data.answer===3){
                                    Wellness.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-LtOL_iR1N-ev2b_8Tmg'){
                            //console.log("Company Alignment",data)
                            if(data.answer!==undefined){
                                Company_Alignment.total++
                                if(data.answer===0||data.answer===1){
                                    Company_Alignment.value++
                                 }
                                }
                         }
                        
                    })
                        PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
                        Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
                        Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
                        Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
                        Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
                        Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
                        Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
                        Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
                        Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

                    })
            firebase.firestore().collection('/users_questions').where('team','==',state.user.teamid).where('date','>=',previous_start_date).where('date','<=',previous_end_date).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    //Personal Growth
                     if(data.quest_id=='-Kgn7oxLPPWlbM_ZDc_h')
                     {
                         
                         if(data.answer!==undefined){
                            PersonalGrowth.previous_total++
                            if(data.answer===0){
                                PersonalGrowth.previous_value++
                             }
                         }
                     }
                     else if(data.quest_id=='-L0J5FFsGQYVkfcGujWo'){
                       // console.log("Recognition",data)
                       if(data.answer!==undefined){
                        Recognition.previous_total++
                        if(data.answer===0){
                            Recognition.previous_value++
                         }
                     }
                     }
                     else if(data.quest_id=='-Kgs549ClADmNQwoNbbG'){
                       // console.log("Relationship with Colleagues",data)
                       if(data.answer!==undefined){
                        Rel_Colleagues.previous_total++
                        if(data.answer===0){
                            Rel_Colleagues.previous_value++
                         }
                        }
                     }
                     else if(data.quest_id=='-L1FmpFO-v8IZc_B5EB7'){
                        //console.log("Satisfaction",data)
                        if(data.answer!==undefined){
                            Satisfaction.previous_total++
                            if(data.answer===0||data.answer===1){
                                Satisfaction.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-L2ycGiBDo3rDGjLNKwW'){
                        //console.log("Ambassadorship",data)
                        if(data.answer!==undefined){
                            Ambassadorship.previous_total++
                            if(data.answer===0){
                                Ambassadorship.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-L1QWPtZvax_KlJgpNxF'){
                        //console.log("Feedback",data)
                        if(data.answer!==undefined){
                            Feedback.previous_total++
                            if(data.answer===0){
                                Feedback.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-L1Qug-PhtzVOR2Dr5q7'){
                        //console.log("Relationship with Managers",data)
                        if(data.answer!==undefined){
                            Rel_Manager.previous_total++
                            if(data.answer===0){
                                Rel_Manager.previous_value++
                             }
                            }
                        
                     }
                     else if(data.quest_id=='-L36rxTgLhZTL4mq4SV1'){
                        //console.log("Wellness",data)
                        if(data.answer!==undefined){
                            Wellness.previous_total++
                            if(data.answer===1||data.answer===2||data.answer===3){
                                Wellness.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-LtOL_iR1N-ev2b_8Tmg'){
                        //console.log("Company Alignment",data)
                        if(data.answer!==undefined){
                            Company_Alignment.previous_total++
                            if(data.answer===0||data.answer===1){
                                Company_Alignment.previous_value++
                             }
                            }
                     }
                    
                })
                    PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
                    PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
                    performingData.push(PersonalGrowth)
                    Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
                    Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
                    performingData.push(Recognition)
                    Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
                    Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
                    performingData.push(Rel_Colleagues)
                    Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
                    Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
                    performingData.push(Satisfaction)
                    Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
                    Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
                    performingData.push(Ambassadorship)
                    Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
                    Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
                    performingData.push(Feedback)
                    Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
                    Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
                    performingData.push(Rel_Manager)
                    Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
                    Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
                    performingData.push(Wellness)
                    Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
                    Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
                    performingData.push(Company_Alignment)

                    // console.log("performingData",performingData)
                    commit('setPerformingData', performingData)
     
                })
                

            }else{
            await firebase.firestore().collection('/users_questions').where('users','==',state.user.email).where('date','>=',start_date).where('date','<=',end_date).get().then((querySnapshot)=>{
                    querySnapshot.forEach((doc) => {
                        const data=doc.data()
                        //Personal Growth
                         if(data.quest_id=='-Kgn7oxLPPWlbM_ZDc_h')
                         {
                             if(data.answer!==undefined){
                                PersonalGrowth.total++
                                if(data.answer===0){
                                    PersonalGrowth.value++
                                 }
                             }
                             
                         }
                         else if(data.quest_id=='-L0J5FFsGQYVkfcGujWo'){
                           //console.log("Recognition",data)
                           if(data.answer!==undefined){
                            Recognition.total++
                            if(data.answer===0){
                                Recognition.value++
                             }
                         }
                         }
                         else if(data.quest_id=='-Kgs549ClADmNQwoNbbG'){
                           //console.log("Relationship with Colleagues",data)
                           if(data.answer!==undefined){
                            Rel_Colleagues.total++
                            if(data.answer===0){
                                Rel_Colleagues.value++
                             }
                         }
                         }
                         else if(data.quest_id=='-L1FmpFO-v8IZc_B5EB7'){
                            if(data.answer!==undefined){
                                Satisfaction.total++
                                if(data.answer===0||data.answer===1){
                                    Satisfaction.value++
                                 }
                            }
                        
                         }
                         else if(data.quest_id=='-L2ycGiBDo3rDGjLNKwW'){
                            //console.log("Ambassadorship",data)
                            if(data.answer!==undefined){
                                Ambassadorship.total++
                                if(data.answer===0){
                                    Ambassadorship.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-L1QWPtZvax_KlJgpNxF'){
                            //console.log("Feedback",data)
                            if(data.answer!==undefined){
                                Feedback.total++
                                if(data.answer===0){
                                    Feedback.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-L1Qug-PhtzVOR2Dr5q7'){
                            //console.log("Relationship with Managers",data)
                            if(data.answer!==undefined){
                                Rel_Manager.total++
                                if(data.answer===0){
                                    Rel_Manager.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-L36rxTgLhZTL4mq4SV1'){
                            //console.log("Wellness",data)
                            if(data.answer!==undefined){
                                Wellness.total++
                                if(data.answer===1||data.answer===2||data.answer===3){
                                    Wellness.value++
                                 }
                                }
                         }
                         else if(data.quest_id=='-LtOL_iR1N-ev2b_8Tmg'){
                            //console.log("Company Alignment",data)
                            if(data.answer!==undefined){
                                Company_Alignment.total++
                                if(data.answer===0||data.answer===1){
                                    Company_Alignment.value++
                                 }
                                }
                         }
                        
                    })
                        PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
                        Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
                        Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
                        Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
                        Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
                        Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
                        Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
                        Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
                        Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

                    })
            firebase.firestore().collection('/users_questions').where('users','==',state.user.email).where('date','>=',previous_start_date).where('date','<=',previous_end_date).get().then((querySnapshot)=>{
                querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    //Personal Growth
                     if(data.quest_id=='-Kgn7oxLPPWlbM_ZDc_h')
                     {
                         
                         if(data.answer!==undefined){
                            PersonalGrowth.previous_total++
                            if(data.answer===0){
                                PersonalGrowth.previous_value++
                             }
                         }
                     }
                     else if(data.quest_id=='-L0J5FFsGQYVkfcGujWo'){
                       // console.log("Recognition",data)
                       if(data.answer!==undefined){
                        Recognition.previous_total++
                        if(data.answer===0){
                            Recognition.previous_value++
                         }
                     }
                     }
                     else if(data.quest_id=='-Kgs549ClADmNQwoNbbG'){
                       // console.log("Relationship with Colleagues",data)
                       if(data.answer!==undefined){
                        Rel_Colleagues.previous_total++
                        if(data.answer===0){
                            Rel_Colleagues.previous_value++
                         }
                        }
                     }
                     else if(data.quest_id=='-L1FmpFO-v8IZc_B5EB7'){
                        //console.log("Satisfaction",data)
                        if(data.answer!==undefined){
                            Satisfaction.previous_total++
                            if(data.answer===0||data.answer===1){
                                Satisfaction.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-L2ycGiBDo3rDGjLNKwW'){
                        //console.log("Ambassadorship",data)
                        if(data.answer!==undefined){
                            Ambassadorship.previous_total++
                            if(data.answer===0){
                                Ambassadorship.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-L1QWPtZvax_KlJgpNxF'){
                        //console.log("Feedback",data)
                        if(data.answer!==undefined){
                            Feedback.previous_total++
                            if(data.answer===0){
                                Feedback.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-L1Qug-PhtzVOR2Dr5q7'){
                        //console.log("Relationship with Managers",data)
                        if(data.answer!==undefined){
                            Rel_Manager.previous_total++
                            if(data.answer===0){
                                Rel_Manager.previous_value++
                             }
                            }
                        
                     }
                     else if(data.quest_id=='-L36rxTgLhZTL4mq4SV1'){
                        //console.log("Wellness",data)
                        if(data.answer!==undefined){
                            Wellness.previous_total++
                            if(data.answer===1||data.answer===2||data.answer===3){
                                Wellness.previous_value++
                             }
                            }
                     }
                     else if(data.quest_id=='-LtOL_iR1N-ev2b_8Tmg'){
                        //console.log("Company Alignment",data)
                        if(data.answer!==undefined){
                            Company_Alignment.previous_total++
                            if(data.answer===0||data.answer===1){
                                Company_Alignment.previous_value++
                             }
                            }
                     }
                    
                })
                    PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
                    PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
                    performingData.push(PersonalGrowth)
                    Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
                    Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
                    performingData.push(Recognition)
                    Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
                    Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
                    performingData.push(Rel_Colleagues)
                    Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
                    Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
                    performingData.push(Satisfaction)
                    Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
                    Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
                    performingData.push(Ambassadorship)
                    Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
                    Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
                    performingData.push(Feedback)
                    Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
                    Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
                    performingData.push(Rel_Manager)
                    Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
                    Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
                    performingData.push(Wellness)
                    Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
                    Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
                    performingData.push(Company_Alignment)

                    //console.log("performingData",performingData)
                    commit('setPerformingData', performingData)
                    // console.log("PersonalGrowth",PersonalGrowth)
                    // console.log("Recognition",Recognition)
                    // console.log("Rel_Colleagues",Rel_Colleagues)
                    // console.log("Satisfaction",Satisfaction)
                    // console.log("Ambassadorship",Ambassadorship)
                    // console.log("Feedback",Feedback)
                    // console.log("Rel_Manager",Rel_Manager)
                    // console.log("Wellness",Wellness)
                    // console.log("Company_Alignment",Company_Alignment)
                })
            }
        },
        async updateEnable({ commit, state }: any, emailKey: any) {
            firebase.database().ref(`/users/${emailKey}`).update({
                ai_daily:true
              })
        },
      

    },
    getters: {
        user: (state: any) => {
            return state.user
          },
        teamAll: (state: any) => {
            return state.teamAll
          },
        contributions: (state: any) => {
            return state.dailyContributions
          },
        youFeeling: (state: any) => {
            return state.youFeeling
          },
        teamFeeling: (state: any) => {
            return state.teamFeeling
          },
        feeling: (state: any) => {
            return state.feeling
          },
        performingData: (state: any) => {
            return state.performingData
          },
        growingData: (state: any) => {
            return state.growingData
          },
        directReportsCardData: (state: any) => {

            return state.directReportsCardData
          },
        userCardData: (state: any) => {
            return state.userCardData
          },
        loadingStatus: (state: any) => {
            return state.loadingStatus
          },
    }
  }